import { Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CustomerCategoryEnum } from 'libs/ng-components/utils/src/lib/enums/customer-category.enum';
import { ENVIRONMENT_TOKEN, EnvironmentToken } from '../models/environment-injection.interface';

@Directive({
  selector: '[appCustomerCategory]'
})
export class CustomerCategoryDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    @Inject(ENVIRONMENT_TOKEN) private environment: EnvironmentToken
  ) {}

  @Input() set appCustomerCategory(customerCategories: CustomerCategoryEnum[]) {
    const customerCategoryFromConfig = this.environment.customerCategory;
    const isCustomerAllowedToView = customerCategories.some(
      (category: CustomerCategoryEnum) => category === customerCategoryFromConfig
    );
    if (isCustomerAllowedToView && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isCustomerAllowedToView && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
